module.exports = __webpack_public_path__ + "img/31.3cfa341b.png";